class ApprovalModalController {
  constructor(AuthenticationService, $http, $uibModalInstance, $rootScope, items){
    "ngInject";
    var self = this;
    this.items = items;
    this.$http = $http;
    this.$uibModalInstance = $uibModalInstance;
    this.$rootScope = $rootScope;
  }

  ok(){
    let self = this;
    let timesheetIds = [];

    this.items.forEach( (ts) => {
      timesheetIds.push(ts.id);
    });

    let obj = {
      status: 'APPROVE',
      timesheets: timesheetIds,
    };

    self.$http.post(`${self.$rootScope.apiHost}/api/review/timesheets`, obj, {withCredentials: true}).then(function (success) {
      self.$uibModalInstance.close();
      self.$uibModalInstance.success();
    });
  }

  cancel(){
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default ApprovalModalController;



// WEBPACK FOOTER //
// ./client/pages/review/modals/approval/approval.controller.js